<template>
  <div class="pwmat-introduce-background">
    <div class="pwmat-introduce-banner">
      <div class="pwmat-introduce-container">
        <div class="pwmat-introduce-banner-title">IntelliMat</div>
      </div>

      <img class="pwmat-introduce-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="pwmat-introduce-container">
      <div class="pwmat-introduce-content">
        <div class="pwmat-introduce-content-info">
          <div
            class="intellimat-markdown-content"
            v-html="markdownHtml"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import intelliMatMd from '!!../../../loaders/md-loader.js!@/common/lang/zh/IntelliMat.md'
import intelliMatMdEn from '!!../../../loaders/md-loader.js!@/common/lang/en/IntelliMat.md'
import { parseMarkdown } from '@/utils/simpleMarkdown'
import intelliMatKnowledge from '@/assets/produce/intellimat/1-知识.gif'
import intelliMatTool from '@/assets/produce/intellimat/2-工具和沙盒.gif'
import intelliMatSkill from '@/assets/produce/intellimat/3-技能.gif'
import intelliMatAll from '@/assets/produce/intellimat/编排与应用整体.gif'
import intelliMatOverview1 from '@/assets/produce/intellimat/intellimat-1.png'
import intelliMatOverview2 from '@/assets/produce/intellimat/intellimat-2.png'
import intelliMatOverview3 from '@/assets/produce/intellimat/intellimat-3.png'

const intelliMatImages = {
  '1-知识.gif': intelliMatKnowledge,
  '2-工具.gif': intelliMatTool,
  '3-技能.gif': intelliMatSkill,
  '4-编排.gif': intelliMatAll,
  'intellimat-1.png': intelliMatOverview1,
  'intellimat-2.png': intelliMatOverview2,
  'intellimat-3.png': intelliMatOverview3,
}

export default {
  name: 'IntelliMatIntroduce',
  computed: {
    markdownHtml() {
      if (this.$i18n.locale === 'en') {
        return parseMarkdown(intelliMatMdEn, { images: intelliMatImages })
      }
      return parseMarkdown(intelliMatMd, { images: intelliMatImages })
    }
  }
}
</script>

<style scoped>
.pwmat-introduce-container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.pwmat-introduce-background {
  margin-top: 70px;
}
.pwmat-introduce-banner {
  overflow: hidden;
}
.pwmat-introduce-banner-title {
  font-size: 24px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  position: absolute;
  margin-top: 60px;
}
.pwmat-introduce-banner-img {
  min-width: 100%;
  height: 165px;
}
.pwmat-introduce-content {
  margin-top: 30px;
  margin-bottom: 90px;
}
.pwmat-introduce-content-info {
  margin-top: 40px;
}
.intellimat-markdown-content {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
}
.intellimat-markdown-content >>> h2 {
  margin-top: 40px;
  margin-bottom: 16px;
  font-size: 24px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 36px;
}
.intellimat-markdown-content >>> h3 {
  margin-top: 20px;
  margin-bottom: 16px;
  font-size: 30px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 50px;
  text-align: center;
}
.intellimat-markdown-content >>> p {
  margin-bottom: 16px;
}
.intellimat-markdown-content >>> .md-image-row {
  display: flex;
  justify-content: center;
  margin: 24px 0;
}
.intellimat-markdown-content >>> .md-image {
  display: block;
  max-width: 100%;
  height: auto;
}
.intellimat-markdown-content >>> .md-image[alt="IntelliMat 知识库"] {
  width: 100%;
}
.intellimat-markdown-content >>> ol {
  padding-left: 20px;
  margin-bottom: 16px;
}
.intellimat-markdown-content >>> li {
  margin-bottom: 8px;
}
@media screen and (max-width: 482px) {
  .pwmat-introduce-container {
    max-width: 100%;
  }
}
@media screen and (min-width: 482px) and (max-width: 768px) {
  .pwmat-introduce-container {
    max-width: 450px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1100px) {
  .pwmat-introduce-container {
    max-width: 736px;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1444px) {
  .pwmat-introduce-container {
    max-width: 1068px;
  }
}
@media screen and (min-width: 1444px) {
  .pwmat-introduce-container {
    max-width: 1068px;
  }
}
</style>
